/**
 * Document Bank foldings
 */
(function ($){
    const foldingTitleSelector = '.doc__category-folder'
    const foldingContentSelector = '.doc__category-content'
    const effectSpeed = 400

    $('.doc__category-item').each(function(){
        const foldingContainer = $(this),
            foldingContainerSiblings = foldingContainer.siblings(),
            foldingTitle = foldingContainer.find(foldingTitleSelector),
            foldingContent = foldingContainer.find(foldingContentSelector),
            foldingContentSiblings = foldingContainerSiblings.find(foldingContentSelector)

        foldingTitle.on('click', function(){
            foldingContent.slideToggle(effectSpeed)
            foldingContentSiblings.slideUp(effectSpeed)

            foldingContainer.toggleClass('active').toggleClass('_show-secondary')
            foldingContainerSiblings.removeClass('active').removeClass('_show-secondary')
        })
    })
})(jQuery)
